import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../core/backend-adapter/api/api.service';
import { ABP_TABS } from './abp-tabs.constants';

@Component({
  selector: 'app-abp-management',
  templateUrl: './abp-management.component.html',
  styleUrls: ['./abp-management.component.scss'],
})
export class AbpManagementComponent implements OnInit, OnDestroy {
  abpTabs: typeof ABP_TABS = ABP_TABS;

  // tab menu
  tabItems: MenuItem[];

  activeItem: MenuItem;

  private unsubscribe$ = new Subject<void>();

  constructor(private apiService: ApiService) {
    this.tabItems = Object.values(this.abpTabs).map((tabName) => {
      return {
        label: tabName,
        // disabled: tabName == this.abpTabs.PHOTO || tabName == this.abpTabs.QA,
        hash: tabName.split(' ').join('-').toLowerCase(),
        command: (event) => {
          this.setActiveTab(event.item);
        },
      };
    });
    this.activeItem = this.tabItems[0];
  }

  ngOnInit(): void {
    this.apiService
      .get('Account')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        // console.log(res);
      });
  }

  // tab menu navigation
  setActiveTab(item) {
    this.activeItem = item;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
